export class NewFormDetails {
  public SSN: any;
  public firstName: any;
  public middleInitial: any;
  public lastName: any;
  public DOB: Date;
  public gender: any;
}
